import { camelCaseToSpacedString } from '../../../../../utils/generalHelpers';
import { ExamHistory } from '../../../../../store/workspace/types';
import Button from '../../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';

interface Props {
    info: ExamHistory;
};

function AppliedJobCard(props: Props) {
    const { info } = props;
    const navigate = useNavigate();
    const date = info.lastModified.slice(0, 10).split('-');

    const resumeInterview = () => {
        navigate('/examination/interview', {
            state: {
                jobId: info.id,
                action: 'resume',
                examId: info.multipleChoiceExamId,
            }
        })
    }

    const resumeMultipleChoiceExam = () => {
        navigate('/examination/multipleChoice', {
            state: {
                jobId: info.id,
                action: 'resume',
                examId: info.multipleChoiceExamId,
            }
        })
    }

    const resumeCodingExam = () => {
        navigate('/examination/coding', {
            state: {
                jobId: info.id,
                action: 'resume',
                examId: info.codingExamId,
                langs: [info.selectedLanguage],
                jobTitle: info.title,
            }
        })
    }

    return (
        <div className={styles.wrapper}>
            <span className={styles.job_title}>{info.title}</span>
            <span className={styles.date}>{`${date[1]}/${date[2]}/${date[0]}`}</span>
            <span className={styles.status}>
                {camelCaseToSpacedString(info.status)}
                {info.status === 'finalResult' && info.finalize && <b> ({camelCaseToSpacedString(info.finalize)})</b>}
            </span>
            {info.status === 'recruitingInterviewRunning' && <Button
                type='Outline-Error'
                text='Continue interview'
                onClick={resumeInterview}
                className={styles.continue_interview_btn}
            />}
            {info.status === 'multipleChoiceExamRunning' && <Button
                type='Outline-Error'
                text='Continue exam'
                onClick={resumeMultipleChoiceExam}
                className={styles.continue_interview_btn}
            />}
            {info.status === 'codingExamRunning' && <Button
                type='Outline-Error'
                text='Continue exam'
                onClick={resumeCodingExam}
                className={styles.continue_interview_btn}
            />}
        </div>
    )
};

export default AppliedJobCard;
